import styled from 'styled-components';
import CopyIcon from 'js/components/core/Icons/CopyIcon';

export default styled(CopyIcon)`
  height: 1rem;
  width: 1rem;
  margin: 0 1rem;
`;
